module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div><ul><a class="snippet has-ripple ripple-primary" href="#" data-click="click-accessory"><span><p><em>'+
((__t=( term ))==null?'':__t)+
'</em>, ';
 if ( getId ) { 
__p+=' <small>id: '+
((__t=( getId ))==null?'':__t)+
', ';
 } 
__p+=' <time class="timestamp" datetime="'+
((__t=( timestamp ))==null?'':__t)+
'">'+
((__t=( datetime ))==null?'':__t)+
'</time></small></p></span></a></ul></div>';
}
return __p;
};
